export const urls = {
    userLogin: '/BBTLogin',
    getCities: '/BBTBookingChart/APIGetCities',
    getSearchRoutesBookBusTickets: '/BBTBookingChart/SearchRoutesBookBusTickets',
    getChartBBT: '/BBTBookingChart/APIGetChartBBT',
    getServerTime: '/Common/GetServerTime',
    getRouteDetails: '/BBTBookingChart/GetRouteDetails',
    getCompanyAgentsRightsListAll: '/BBTBookingChart/CompanyAgentsRightsListAll',
    getCancellationPoliciesV3: '/BBTBookingChart/APIGetCancellationPoliciesV3',
    getBBTPaymentConfig: '/BBTBooking/BBTPaymentConfig',
    updateBookingsInsertUpdate: '/BBTBooking/BookingsInsertUpdateForBookBusTicketsV6',
    getBookingsLoad: '/BBTBooking/LoadBySearch',
    updateBookingsModify: '/BBTBooking/BookingsModify',
    getBookingsCancelV2: '/BBTCancelTicket/BookingsCancelV2',
    checkBeneficiaryStatus: '/BBTBooking/BBTBeneficiary',
    generateQROrders: '/v1/orders',
    bookingQrBkgDetailsInsertUpdate: '/BBTBooking/BBTQrBkgDetailsInsertUpdate',
    bookingPaymentUnutilized: '/BBTBooking/BBTPaymentUnutilized',
    getConsumedList: '/v1/orders/notConsumed',
    generateQRRefund: '/v1/orders/refund',
    getBBTLoginCompany: '/BBTBooking/BBTLoginCompany',
    getAgentUsersChangePassword: '/BBTBooking/AgentUsersChangePassword',
    getAgentUsersListAll: '/Common/AgentUsersListAll',
    getBookingsUserWiseCollAgents: '/BBTReport/BookingsUserWiseCollAgents',
    getCompaniesListAllByAgentsAndDate: "/BBTReport/CompaniesListAllByAgentsAndDate",
    getAgentTicketsDetailedView: '/BBTReport/AgentTicketsDetailedView',
    getCompaniesListAllByAgents: '/BBTReport/CompaniesListAllByAgents',
    getRptAgentTransactions: '/BBTReport/RptAgentTransactions',
    getInquiryReport: '/BBTReport/GetInquiryReport',
    getInquiryAgent2Report: '/BBTReport/GetInquiryAgent2Report',
    getAgentBalance: '/BBTBookingChart/GetAgentBalance',
    getGPSCacheStatus: '/BBTBookingChart/GetGPSCacheStatus',
    getBBTViaListCities: '/BBTBookingChart/BBTViaListCities',
    checkSumForWebLogin: '/BBTBookingChart/CheckSumForWebLogin',
    getBookingDetailsToPrintAgents: '/BBTBooking/BookingDetailsToPrintAgents',
    getBusTripGPSDetails: '/BBTGPSMap/BusTripGPSDetails',
    updateCallIntanglesAPI: '/BBTGPSMap/CallIntanglesAPI',
    updateCallTracknetAPI: '/BBTGPSMap/CallTracknetAPI',
    getBusTrackingMapLink: '/BBTGPSMap/GetBusTrackingMapLink',
    getYourBusTracking: '/BBTGPSMap/GetYourBusTracking',
    getAPIGetPickupsDropoffsBBT: '/BBTBookingChart/APIGetPickupsDropoffsBBT',
    getBookingsModifyWithNameChangeV2: '/BBTBooking/BookingsModifyWithNameChangeV2'
}
export const reportGenerationDateFormat = "DD MMM YYYY, ddd, HH:mm"
export const reportGenerationDateFormat2 = "DD-MMM-YYYY hh:mm A"